import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { useAuth } from "../common/context/clientContext";
import { axiosPost } from "../common/services/axios/apiCalls"
import SetLoading from "../common/components/modals/setLoadingModal";
import Footer from "../common/components/footer/footer";

import MenuBar from "../components/menuBar/menuBar";
import CatalogCard from "../components/card/catalogCard";

export default function Catalog({ additionalParams }) {
    /** CONST */
    const navigate = useNavigate();
    const { token } = useAuth()
    const [loading, setLoading] = useState(false)
    const [categories, setCategories] = useState([])
    const [subcategories, setSubcategories] = useState([])
    const [icons, setIcons] = useState([])

    /** PARAMS */
    const { category } = useParams();

    const getCatalogUsername = async () => {
        setLoading(true);

        const axiosData = {
            code: `${process.env.REACT_APP_COMPANY}`
        }

        try {
            const response = await axiosPost("/public/catalog/category/read", token, axiosData)
            if (response.status.code == 401) throw 'Session not accepted'
            setLoading(false);
            return response.data
        } catch (error) {
            setLoading(false);
            navigate('/notfound?message=ApiError');
        }
    }

    const getSubCatalog = async () => {
        setLoading(true);

        const axiosData = {
            code: category
        }

        try {
            const response = await axiosPost("/public/catalog/subcategory/read", token, axiosData)
            setLoading(false);
            return response.data
        } catch (error) {
            setLoading(false);
        }
    }

    const getIcons = async () => {
        setLoading(true);

        const axiosData = {
            code: category || null
        }

        try {
            const response = await axiosPost("/public/icon/get/all", token, axiosData)
            setLoading(false);
            return response.data
        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            setCategories(await getCatalogUsername())
            setIcons(await getIcons())
            if (category) {
                setSubcategories(await getSubCatalog())
            } else {
                setSubcategories([])
            }
        };

        fetchData();
    }, [category])

    return (
        <div className="d-flex flex-column min-vh-100">
            {loading && <SetLoading />}
            {!loading && categories &&
                <>
                    <div className="flex-grow-1">
                        <MenuBar menuItems={categories} searchBar={category ? true : false} />
                        <div className="container-xxl">
                            {!category && <CatalogCard allowActions={additionalParams} icons={icons} catalog={categories} />}
                            {category && <CatalogCard allowActions={additionalParams} icons={icons} catalog={subcategories} category={category} />}
                        </div>
                    </div>
                    <Footer />
                </>
            }
        </div>
    );
}
